import Item from "./Item";

const DocumentDownload = ({ items, download, downloadLabel }) => {
  if (!items?.length) {
    return null;
  }

  return (
    <div className="acoris-recap__documents--list">
      {items.map((item, index) => (
        <Item
          key={item.id || `key-${index}`}
          name={item.name}
          onDownload={() => download(item.id)}
          downloadLabel={downloadLabel}
          isFirst={index === 0}
          isLast={index === items.length - 1}
        />
      ))}
    </div>
  );
};

export default DocumentDownload;
